import React, { useEffect } from 'react';

import { TablePagination } from '@material-ui/core';

import { PaginationParams } from 'types';

export interface TablePaginationComponentProps {
  count: number;
  paginationParams: PaginationParams;
  onChangePaginationParams: (paginationParams: PaginationParams) => void;
}

export const TablePaginationComponent = ({
  count,
  paginationParams,
  onChangePaginationParams,
}: TablePaginationComponentProps) => {
  const { page, perPage } = paginationParams;

  useEffect(() => {
    checkMaxPage(count);
  }, [count]);

  const handleChangePage = (_: React.MouseEvent<HTMLButtonElement> | null, page: number) =>
    onChangePaginationParams({ ...paginationParams, page });

  const checkMaxPage = (count: number) => {
    if (count === 0 && paginationParams.page === 0) {
      return;
    }

    if (Math.ceil(count / paginationParams.perPage) - 1 < paginationParams.page) {
      const newCurrentPage = Math.max(paginationParams.page - 1, 0);

      handleChangePage(null, newCurrentPage);
    }
  };

  const handleChangeRowsPerPage = (value: number) => {
    if (Number.isNaN(value) || value <= 0) {
      return;
    }

    const countProductList = Math.ceil(paginationParams.page * paginationParams.perPage);
    const necessaryPage = Math.ceil(countProductList / value);
    const maxPage = Math.ceil(count / value);
    const currentPage = necessaryPage > maxPage ? maxPage - 1 : necessaryPage;

    onChangePaginationParams({
      ...paginationParams,
      perPage: value,
      page: currentPage === 1 ? 0 : currentPage,
    });
  };

  if (count === 0) {
    return null;
  }

  return (
    <TablePagination
      rowsPerPageOptions={[5, 10, 25]}
      component="div"
      count={count}
      rowsPerPage={perPage}
      page={page}
      onChangePage={handleChangePage}
      onChangeRowsPerPage={(event: React.ChangeEvent<HTMLInputElement>) =>
        handleChangeRowsPerPage(Number(event.target.value))
      }
    />
  );
};
